import axios from 'axios';
import router from "../router";
// 登录请求方法
const loginreq = (method, url, params) => {
    return axios({
        method: method,
        url: 'https://lvpaperapp.xcthrone.top/admin'+url,
      // url: 'https://d9d4119.r22.cpolar.top/admin' + url,
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
        },
        data: params,
        traditional: true,
        transformRequest: [
            function(data) {
                let ret = ''
                for (let it in data) {
                    ret +=
                        encodeURIComponent(it) +
                        '=' +
                        encodeURIComponent(data[it]) +
                        '&'
                }
                return ret
            }
        ]
    }).then(res => res.data);
};
// 通用公用方法
const req = (method, url, params) => {
    return axios({
        method: method,
        url: 'https://testmfpaperapp.xcthrone.top/admin' + url,
      // url: 'https://d9d4119.r22.cpolar.top/admin' + url,
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'satoken': localStorage.getItem('satoken')
        },
        data: params,
        traditional: true,
        transformRequest: [
            function(data) {
                let ret = ''
                for (let it in data) {
                    ret +=
                        encodeURIComponent(it) +
                        '=' +
                        encodeURIComponent(data[it]) +
                        '&'
                }
                return ret
            }
        ]
    }).then(res => {
      if(res.data.code == '401'){ //登陆失效
        router.push({path: "/login"})
        window.localStorage.removeItem('satoken')
      }
      return res.data
    });
};

export {
    loginreq,
    req
}



// WEBPACK FOOTER //
// ./src/api/axiosFun.js